// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__Xgt2b","ticketCounterText":"pagination_ticketCounterText__fpKKm"};